import * as getJSON from "./getJSON";
import Mustache from "mustache";
import _, {} from "underscore";
import { alertCheck } from "./libAlerts";
import $ from "jquery";

alertCheck();

function libcalNavBar() {
	const jbcNav = $(".header-nav-hours li.jbc");
	const hslNav = $(".header-nav-hours .tml");
	const chatNav = $(".header-nav-hours .chat");

	function allDay(element) {
		let name = element.name == "James Branch Cabell Library" ? "Cabell" : "Health Sciences";
		jbcNav.html('<a href="https://library.vcu.edu/spaces-tech/james-branch-cabell-library/">' + name + '</a>:<a href="https://library.vcu.edu/spaces-tech/james-branch-cabell-library/hours/" style="font-weight: 400;"> Open 24 Hours</a>');
	}

	// pre launch
	function openClose(element) {
	
		if (!element.times.hours) {
			closedToday(element);
			return;
		}

		let from = element.times.hours[0].from;
		let to = element.times.hours[0].to;

		var name, formatTime;

		formatTime = from + " - " + to;

		if (element.name === "James Branch Cabell Library") {
			name = "Cabell";
			jbcNav.html('<a href="https://library.vcu.edu/spaces-tech/james-branch-cabell-library/">' + name + "</a>: " + formatTime);
		}
		if (element.name === "Health Sciences Library") {
			name = "Health Sciences";
			hslNav.html('<a href="https://library.vcu.edu/spaces-tech/health-sciences-library/">' + name + "</a>: " + formatTime);
		}

		function closedToday(element) {
			if (element.name === "James Branch Cabell Library") {
				name = "Cabell";
				jbcNav.html('<a href="https://library.vcu.edu/spaces-tech/james-branch-cabell-library/">' + name + "</a>: " + "Closed");
			}
			if (element.name === "Health Sciences Library") {
				name = "Health Sciences";
				hslNav.html('<a href="https://library.vcu.edu/spaces-tech/health-sciences-library/">' + name + "</a>: " + "Closed");
			}
		}

		if (element.name == "Chat")
			$.get("https://apps.library.vcu.edu/pub_scripts/js/templates/chat.html", function (template) {
				var rendered = Mustache.render(template, {
					title: "Chat",
					start: from,
					end: to,
				});
				chatNav.html(rendered);
			});
	}

	function buildingPages(element) {
		const jbcToday = $(".info-spotlight.jbc > p:first-of-type");
		const hslToday = $(".info-spotlight.tml > p:first-of-type");
		const wsToday = $(".im.hours");

		//TODO: this is a mess
		if (window.location.pathname == "/spaces-tech/james-branch-cabell-library/" && element.name == "James Branch Cabell Library") {
			jbcTime(element);
		}
		if (window.location.pathname == "/about/" && element.name == "James Branch Cabell Library") {
			jbcTime(element);
		}
		if (window.location.pathname == "/research-teaching/ask-us/" && element.name == "James Branch Cabell Library") {
			jbcTime(element);
		}
		if (window.location.pathname == "/spaces-tech/health-sciences-library/" && element.name == "Health Sciences Library") {
			hslTime(element);
		}
		if (window.location.pathname == "/research-teaching/ask-us/" && element.name == "Health Sciences Library") {
			hslTime(element);
		}
		if (window.location.pathname == "/about/" && element.name == "Health Sciences Library") {
			hslTime(element);
		}
		if (document.location.pathname.toString().indexOf("special-collections") && element.name == "Special Collections and Archives at Cabell Library") {
			scaTime(element, "JBC");
		}
		if (document.location.pathname.toString().indexOf("special-collections") && element.name == "Special Collections and Archives at the Health Sciences Library") {
			scaTime(element, "HSL");
		}
		if (document.location.pathname.toString().indexOf("the-workshop") && element.name == "The Workshop") {
			wsTime(element);
		}

		if (window.location.pathname == "/spaces-tech/" && element.name == "James Branch Cabell Library") {
			jbcTime(element);
		}
		if (window.location.pathname == "/spaces-tech/" && element.name == "Health Sciences Library") {
			hslTime(element);
		}

		function jbcTime(element) {
			let timeJBC = "<p><strong>Today's hours: " + element.rendered + "</strong></p>";
			jbcToday.append(timeJBC);
		}

		function hslTime(element) {
			let timeHSL = "<p><strong>Today's hours: " + element.rendered + "</strong></p>";
			hslToday.append(timeHSL);
		}

		function wsTime(element) {
			let timeWS = "<strong><a style='text-decoration: underline;' href='https://www.library.vcu.edu/spaces-tech/hours/'>Today's hours: " + element.rendered + "</a></strong>";
			wsToday.html(timeWS);
		}
		function scaTime(element, local) {
			let scaToday = $("p.sca-hours-hsl-js");
			if(local === "JBC") {
				scaToday = $("p.sca-hours-jbc-js");
			}

			if (scaToday) {
				let timeSCA = "<strong>Today's hours: </strong> " + element.rendered;
				scaToday.html(timeSCA);
			}
		}
	}

	getJSON.loadJSON("https://apps.library.vcu.edu/pub_scripts/php/libcal_hours.php", (data) => {
		data = data.locations;

		let libLocation = _.where(data, { category: "library" });
		let chatLocation = _.where(data, { name: "Chat" });
		let wsLocation = _.where(data, { name: "The Workshop" });
		let scaLocationJBC = _.where(data, { name: "Special Collections and Archives at Cabell Library" });
		let scaLocationHSL = _.where(data, { name: "Special Collections and Archives at the Health Sciences Library" });

		libLocation.forEach((element) => {
			if (element.times.status === "24hours") {
				allDay(element);
			} else {
				openClose(element);
				buildingPages(element);
			}
		});

		chatLocation.forEach((element) => {
			if (element.times.status === "24hours") {
				allDay(element);
			} else {
				openClose(element);
				buildingPages(element);
			}
		});

		scaLocationJBC.forEach((element) => {
			buildingPages(element, "JBC");
		});

		scaLocationHSL.forEach((element) => {
			buildingPages(element, "HSL");
		});

		wsLocation.forEach((element) => {
			if (element.times.status === "24hours") {
			} else {
				openClose(element);
				buildingPages(element);
			}
		});
	});
}

export function getLibCal() {
	libcalNavBar();
}
